import { render, staticRenderFns } from "./NavDropdown.vue?vue&type=template&id=2bd5e180&scoped=true&"
import script from "./NavDropdown.vue?vue&type=script&lang=js&"
export * from "./NavDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NavDropdown.vue?vue&type=style&index=0&id=2bd5e180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5e180",
  null
  
)

export default component.exports